import { ComposeOperation } from 'owa-mail-compose-store';
import ItemId from 'owa-service/lib/contract/ItemId';
import { action } from 'satcheljs';

export default action(
    'ON_SEND_MESSAGE_SUCCEEDED',
    (operation: ComposeOperation, referenceItemId: ItemId, composeId: string) => {
        return {
            operation,
            referenceItemId,
            composeId,
        };
    }
);
